import { IconLink, type TextColorType } from "@/lib/main";
import { CSSProperties } from "react";

type Props = {
  logoutLinkColor?: TextColorType;
  logoutLinkText?: string;
  logoutPath?: string;
};

export default function LogoutLink({
  logoutLinkColor,
  logoutLinkText,
  logoutPath,
}: Props) {
  const logoutLinkStyle: CSSProperties = {
    paddingInlineStart: "var(--spacing-sm)",
    lineHeight: "var(--navbar-height)",
    color: logoutLinkColor || "var(--color-text-danger)",
    fontSize: "var(--font-size-navbar-item)",
    fontWeight: 500,
  };

  return (
    <IconLink
      iconColor="danger"
      iconName="logout"
      linkTitle={logoutLinkText || "Logout"}
      style={logoutLinkStyle}
      to={logoutPath || "/logout"}
    />
  );
}
